const themeObj = {
    0: { key: -1, name: 'purple-theme', color: '#4b28a3', otherColor: '#6b278e' },
    1: { key: 1, name: 'red-theme', color: '#ef373f', otherColor: '#fd7857' },
    2: { key: 2, name: 'green-theme', color: '#088421', otherColor: '#57bc6c' },
    3: { key: 3, name: 'blue-theme', color: '#1579e6', otherColor: '#72a2d9' },
    4: { key: 4, name: 'orange-theme', color: '#e86c0f', otherColor: '#F58B3D' },
    5: { key: 5, name: 'yellow-theme', color: '#FFC107', otherColor: '#f2d642' },
    6: { key: 6, name: 'purple-theme', color: '#4b28a3', otherColor: '#6b278e' },
    7: { key: 7, name: 'gold-theme', color: 'rgb(158, 146, 110)', otherColor: 'rgb(222, 211, 179)' },
    8: { key: 8, name: 'p-green-theme', color: 'rgb(29, 93, 90)', otherColor: '#4aa395' },
    9: { key: 9, name: 'plum-purple', color: '#a00062', otherColor: '#ab0d6c' },
    10: { key: 10, name: 'aira-green', color: '#086451', otherColor: '#076e58' },
    11: { key: 11, name: 'brown-theme', color: '#9b372f', otherColor: '#9d5550' },
    12: { key: 12, name: 'pantone-theme', color: '#c6b3a6', otherColor: '#c6b3a6' },
    13: { key: 13, name: 'ihg-purple', color: '#7e81be', otherColor: '#a7a8c3' },
    14: { key: 14, name: 'samala-gold', color: '#bf8c59', otherColor: '#d79d67' },
    15: { key: 15, name: 'new-green', color: '#5dc4b8', otherColor: '#6bded2' },
    16: { key: 16, name: 'deep-blue', color: '#253668', otherColor: '#30437e' },
    17: { key: 17, name: 'matcha-green', color: '#737a47', otherColor: '#696f41' },
    18: { key: 18, name: 'turquoise-green', color: '#5DC1C3', otherColor: '#71d1d3' },
    19: { key: 19, name: 'black-theme', color: '#000', otherColor: '#414141' },
    20: { key: 20, name: 'stellar-blue-theme', color: '#010f2a', otherColor: '#1b2c4d' },
    21: { key: 21, name: 'midnight-blue', color: '#001c33', otherColor: '#003560' },
    22: { key: 22, name: 'dark-lime-green', color: '#3f7a32', otherColor: '#59aa46' },
    23: { key: 23, name: 'Teal', color: '#0ec59e', otherColor: '#3cad95' },
    24: { key: 24, name: 'Dark Cyan-Teal', color: '#418379', otherColor: '#4aa395' },
    25: { key: 25, name: 'Navy Blue', color: '#003C7F', otherColor: '#1658a3' },
    26: { key: 26, name: 'Cobalt Blue', color: '#315394', otherColor: '#3764b9' },
    27: { key: 27, name: 'Midnight Blue', color: '#0B3565', otherColor: '#025192' },
    28: { key: 28, name: 'Crimson', color: '#D11242', otherColor: '#ff0040' },
    29: { key: 29, name: 'Coffee Brown', color: '#6A3F24', otherColor: '#834d2b' },
    30: { key: 30, name: 'Sand Beige', color: '#C2B59D', otherColor: '#ccbfa7' },
    31: { key: 31, name: 'Olive Drab Brown', color: '#403c26', otherColor: '#524d36' },
    32: { key: 32, name: 'Blue Green', color: '#60aab7', otherColor: '#7bb6c0' },
    33: { key: 33, name: 'Deep Teal', color: '#1A4D57', otherColor: '#26636f' },
    34: { key: 34, name: 'Burnt Sienna', color: '#644d18', otherColor: '#7a5f22' },
    35: { key: 35, name: 'Lavender Gray', color: '#A790C4', otherColor: '#c1a9df' },
    36: { key: 36, name: 'Sand Gold', color: '#CBBC80', otherColor: '#b6a873' },
    37: { key: 37, name: 'Core Purple', color: '#451C70', otherColor: '#6f38aa' },
}

export function getTheme(themeId) {
    return themeObj[themeId] || { key: -1, name: 'Dark Cyan-Teal', color: '#418379', otherColor: '#4aa395' };
}

